import { render, staticRenderFns } from "./DataCapacityContent.vue?vue&type=template&id=3c79bd1e&scoped=true"
import script from "./DataCapacityContent.vue?vue&type=script&lang=js"
export * from "./DataCapacityContent.vue?vue&type=script&lang=js"
import style0 from "./DataCapacityContent.vue?vue&type=style&index=0&id=3c79bd1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c79bd1e",
  null
  
)

export default component.exports